<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/X9klLr/tc-custom/9783987445750.jpg?1704425333507" alt="This image is the cover for the book Die enge Pforte, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Die enge Pforte, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Die enge Pforte ist ein Roman von André Gide, der 1909 unter dem Titel La Porte étroite in der Literaturzeitschrift Mercure de France in Paris erschien. Jérôme erzählt die Geschichte seiner unglücklichen Liebe zu Alissa Bucolin. Vautier hatte das Findelkind Lucile – eine Kreolin – aus Martinique mit nach Le Havre gebracht. Jérômes Onkel Bucolin heiratete Lucile, als das leichtsinnige junge Mädchen 16 Jahre alt geworden war – sehr zur Freude des Pastors. Verständlich – entsprach doch der Lebenswandel Luciles überhaupt nicht den Moralvorstellungen der christlichen Kirche. Auch nach ihrer Heirat richtete Lucile in der Familie Bucolin „viel Unheil“ an. Als Mutter von drei Kindern – das waren Jérômes Cousinen Alissa und Juliette sowie der Cousin Robert – ließ sie von ihren Seitensprüngen nicht ab...</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        André Gide
      </h2>
      
      <p class="authorDescription body article">André Paul Guillaume Gide, (* 22. November 1869 in Paris; † 19. Februar 1951 ebenda) war ein französischer Schriftsteller. 1947 erhielt er den Literaturnobelpreis.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7aeca11d